import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import '@ag-grid-community/core/dist/styles/ag-theme-alpine.css';
import { cs2Actions } from '../_actions';

import dateFormat from 'dateformat';


function Executions() {

  const containerStyle = useMemo(() => ({ height: '560px', width: '100%' }), []);
  const modules = useMemo(() => [ClientSideRowModelModule], []);
  const execution = useSelector(state => state.cs2Submission);
  //const { summary } = execution;

  /* for the first time before useeffect runs, we are injecting an empty summary so it will not redener everytime, instead just change the summary values when useeffect runs */
   const summary = Object.keys(execution).length === 0  ? { "nyseStocks": 0, "nyseDollars": 0, "nyseShares": 0, "amexStocks": 0, "amexDollars": 0, "amexShares": 0, "acceptedCount": 0, "rejectedCount": 0} : execution.summary;

  const [tradeDate, setTradeDate] = useState(new Date());

  const dispatch = useDispatch();
    
  const [columnDefs, setColumnDefs] = useState([
	  { field: 'submissionId', width: 140, headerName: 'Transaction Id'},
	  { field: 'basketId', width: 100},
	  { field: 'firmGroupID', headerName: 'MPID', width: 80},
	  { field: 'clearingFirm', headerName: 'CM', width: 70},
	  { field: 'nyseStocks', headerName: 'NYSE Stocks', width: 120, type: 'rightAligned' },
	  { field: 'nyseShares', headerName: 'NYSE Shares', type: 'rightAligned' },
	  { field: 'nyseDollars', headerName: 'NYSE Dollars', type: 'rightAligned' },
	  { field: 'amexStocks', width: 120, type: 'rightAligned' },
	  { field: 'amexShares', type: 'rightAligned' },
	  { field: 'amexDollars', type: 'rightAligned' },
	  { field: 'accepted', width: 120, filter: 'agTextColumnFilter' },
	  { field: 'rejectedReason', width: 400 },
	  { field: 'crossFlag' },
	  { field: 'shortFlag' },  
	  { field: 'buyCM', width: 100 },
	  { field: 'sellCM', width: 100 },
	  
  ]);
  
 useEffect(() => {
	 console.log("------------------- tradeDate -------------------" + tradeDate);
	  
	  console.log("------------------- tradeDate -------------------" + dateFormat(tradeDate, "yyyymmdd"));
	  
      dispatch(cs2Actions.cs2Executions(dateFormat(tradeDate, "yyyymmdd")));
  }, [tradeDate]);
 
  
  const defaultColDef = useMemo(() => {
    return {
      width: 120,
      sortable: true,
      resizable: true,
      wrapText: true,
      autoHeight: true,
    };
  }, []);

  return (
		<div>
			<div className="row-no-margin">
				<div className="col-md-6 alert alert-primary margin-bottom" role="alert" ><span className="space"><strong className="space">Accepted Basket:</strong> { summary.acceptedCount } </span> </div>
				<div className="col-md-6 alert alert-danger margin-bottom" role="alert" ><span className="space"><strong className="space">Rejected Basket:</strong> { summary.rejectedCount } </span></div>
			</div>

				<div style={containerStyle} className="ag-theme-alpine">
				<AgGridReact
					rowData={ execution.items }
					modules={modules}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
				></AgGridReact>
				</div>

			<br/>
			<div className="alert alert-primary margin-bottom" role="alert" >
				<table>
					<thead>
						<tr><th><span className="space">[ NYSE ] </span></th><th><strong>Total Stocks:</strong><span className="space"> { summary.nyseStocks } </span> </th><th><strong>Total Shares:</strong><span className="space"> { summary.nyseShares } </span></th><th><strong>Total Amount:</strong> <span className="space"> $ { summary.nyseDollars } </span> </th></tr>
						<tr><th><span className="space">[ AMEX ] </span></th><th><strong>Total Stocks:</strong><span className="space"> { summary.amexStocks } </span> </th><th><strong>Total Shares:</strong><span className="space"> { summary.amexShares } </span></th><th><strong>Total Amount:</strong><span className="space"> $ { summary.amexDollars } </span> </th></tr>
					</thead>
				</table>
			</div>
		</div>

    
  );
};

export { Executions };